import { getAppId } from 'core/classes/helpers/getAppId'
import { IReference } from 'core/classes/models/IReference'

export const getTranslationStorageKey = (locale: IReference) => {
  const appId = getAppId()
  return `_hp_${appId}_${locale.value}_translations`
}
